import { NextjsBreadcrumbs } from "infra";
import { BreadcrumbsProps } from "typing";

const Breadcrumb = ({ ...restProps }: BreadcrumbsProps) => {
  return <NextjsBreadcrumbs {...restProps} />;
};

export { Breadcrumb };
